var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 5.5C18.201 5.5 13.5 10.201 13.5 16C13.5 21.799 18.201 26.5 24 26.5C29.799 26.5 34.5 21.799 34.5 16C34.5 10.201 29.799 5.5 24 5.5ZM10.5 16C10.5 8.54416 16.5442 2.5 24 2.5C31.4558 2.5 37.5 8.54416 37.5 16C37.5 17.2018 37.343 18.367 37.0483 19.476C42.0027 21.4751 45.5 26.3276 45.5 32C45.5 39.4558 39.4558 45.5 32 45.5C29.0068 45.5 26.2387 44.5244 24.0001 42.8753C21.7612 44.5251 18.9944 45.5 16 45.5C8.54416 45.5 2.5 39.4558 2.5 32C2.5 26.3276 5.99735 21.4751 10.9517 19.476C10.657 18.367 10.5 17.2018 10.5 16ZM12.0419 22.2711C8.20416 23.834 5.5 27.6027 5.5 32C5.5 37.799 10.201 42.5 16 42.5C21.799 42.5 26.5 37.799 26.5 32C26.5 31.0754 26.3808 30.1803 26.1575 29.3285C25.455 29.4414 24.7343 29.5 24 29.5C18.8079 29.5 14.3004 26.5689 12.0419 22.2711ZM29.048 28.5245C29.343 29.6346 29.5 30.7999 29.5 32C29.5 35.3557 28.2756 38.4254 26.2493 40.7868C27.9012 41.8706 29.876 42.5 32 42.5C37.799 42.5 42.5 37.799 42.5 32C42.5 27.6027 39.7958 23.834 35.9581 22.2711C34.476 25.0916 32.0252 27.3234 29.048 28.5245Z",
    fill: "#1C274C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.75966839586535acce2471a3ba22ba36.svg";
export { ForwardRef as ReactComponent };